/* eslint-disable */
import axios from 'axios'
import solver from '../../utils/solve.js'
import { cloneDeep } from 'lodash'
import { proccessConvertLegacyData } from '../../utils/ConvertData.js'

const TOKEN_KEY = 'jwt-token'
const INITCODE = '\n\n\nvoid setup(){\n\n\n}\n\nvoid loop(){\n\n\n}'
const instance = axios.create({
  baseURL: 'https://vlab.pusan.ac.kr'
})

const micomInstance = axios.create({
  baseURL: 'http://vlab.pusan.ac.kr/micom'
})

const setMutlimeterData = function (apps, values) {
  Object.keys(values).forEach(item => {
    const code = item.substr(0, 2)
    if (code === 'VE' || code === 'AE') {
      const id = 'Multimeter_' + Number(item.substr(3))
      const instance = apps.find(child => child.$el.id === id)
      console.log(instance)
      const data = values[item]
      instance.measures = { amper: data.amper[0], resist: data.resist, volt: data.volt[0], unit: code }
    }
  })
}

const getOsciloscopeChannels = function (values, osnumber) {
  const channels = { ch1: { xdata: [], ydata: [] }, ch2: { xdata: [], ydata: [] } }
  Object.keys(values).forEach(namecode => {
    if (namecode.startsWith('OS') && namecode.charAt(namecode.length - 1) === osnumber) {
      if (namecode.charAt(3) === '1') channels.ch1.ydata = cloneDeep(values[namecode].volt)
      else if (namecode.charAt(3) === '2') channels.ch2.ydata = cloneDeep(values[namecode].volt)
    }
  })
  console.log('getOsciloscopeChannels', channels)
  return channels
}
const displayOscilloscopeGraph = function (apps, values, using) {
  if (!using.OS) return
  Object.keys(using.OS).forEach(idname => {
    const number = idname.charAt(idname.length - 1)
    const channels = getOsciloscopeChannels(values, number)
    const instance = apps.find(child => child.$el.id === idname)
    instance.displayOscilloscopeGraph(channels.ch1, channels.ch2)
  })
}
const isEmptyObject = function (obj) {
  return Object.keys(obj).length === 0
}
const getOpponentPinname = function (wirelist, find) {
  const obj = {}
  if (!wirelist) return obj
  Object.keys(wirelist).forEach(key => {
    const ps = wirelist[key].PS
    const ms = wirelist[key].MS

    if (ps.startsWith(find) || ms.startsWith(find)) {
      const opp = ps.startsWith(find) ? ms : ps
      obj.id = key
      obj.pinname = opp
    }
  })
  return obj
}

const setProbeData = function (data) {
  if (!data.PB) return
  const proben = 'E-PB-' // probe code name
  Object.keys(data.PB).forEach(key => {
    const number = key.length < 2 ? '0' + key : key
    const probein = proben + number + '-IN' // 'IN' pin name of probe
    const probeps = proben + number + '-PS'
    const probems = proben + number + '-MS'
    const opp = getOpponentPinname(data.WL, probein)
    const ps = getOpponentPinname(data.WL, probeps)
    const ms = getOpponentPinname(data.WL, probems)
    if (!isEmptyObject(opp)) {
      const oppcn = opp.pinname.substr(0, 5)
      const oppnum = opp.pinname.substr(6, 1)
      const oppch = opp.pinname.substr(opp.pinname.length - 1, 1)
      const oppps = oppcn + oppch + oppnum + '-P' + oppch
      const oppms = oppcn + oppch + oppnum + '-M' + oppch
      if (!isEmptyObject(ps)) data.WL[ps.id] = { PS: oppps, MS: ps.pinname }
      if (!isEmptyObject(ms)) data.WL[ms.id] = { PS: oppms, MS: ms.pinname }
      delete data.WL[opp.id]
    } else {
      if (!isEmptyObject(ps)) delete data.WL[ps.id]
      if (!isEmptyObject(ms)) delete data.WL[ms.id]
    }
  })
}

const state = {
  result: {
    pass: false,
    feedback: '',
    contents: '회로도 설계 및 입력값이 올바른지 확인하세요.',
    title: '시뮬레이션 실패',
    paths: [],
    nodeinfo: {},
    circuitinfo: {},
    values: {}
  },
  socket: {
    uuid: null,
    valid_comp: null
  },
  arduino: {
    code: INITCODE,
    serial: '',
    status: ''
  },
  userData: {},
  elcts: [],
  simulationData: null,
  zoomlevel: 1.0
}

const getters = {
  simulationResult (state) {
    return state.result
  }
}

const mutations = {
  setZoomLevel (state, payload) {
    state.zoomlevel = payload
  },
  setSimulationMessage (state, payload) {
    state.result.title = payload.title
    state.result.contents = payload.contents
    state.result.feedback = payload.feedback
  },
  setEditorContents (state, payload) {
    state.arduino.code = payload
  },
  setSerialContents (state, contents) {
    state.arduino.serial += contents
  },
  deleteEditorContents (state) {
    state.arduino.code = ''
  },
  deleteSerialContents (state) {
    state.arduino.serial = ''
  },
  addUserData (state, payload) {
    state.userData[payload.id] = {}
    state.userData[payload.id].data = payload.data
    // state.userData[payload.id].instance = findVueComponent(this.$app.$children, payload.id)
  },
  deleteUserData (state, id) {
    if (state.userData[id]) delete state.userData[id]
  },
  createCircuitData (state) {
    const wireGroup = this.state.wire.group.list
    const using = this.state.elct.using
    const snapped = this.state.elct.snapped
    const data = {}

    let keys = Object.keys(using)
    if (keys.length) {
      keys.forEach(key => {
        data[key] = {}

        // console.log('what?', using[key])

        Object.keys(using[key]).forEach(idname => {
          const id = idname.substr(idname.indexOf('_') + 1)
          data[key][id] = using[key][idname]
          delete data[key][id].degree
          delete data[key][id].pos
        })
      })
    }

    keys = Object.keys(wireGroup)
    if (keys.length) {
      data.WL = {}
      keys.forEach(key => {
        const wires = wireGroup[key]
        if (wires.length) {
          const groupid = wires[0].groupid
          const size = wires.length
          data.WL[groupid.toString()] = {
            PS: wires[0].pin,
            MS: wires[size - 1].pin
          }
        }
      })
    }

    if (snapped.length) {
      data.SL = {}
      let i = 0
      snapped.forEach(socket => {
        data.SL[i] = socket
        i += 1
      })
    }
    setProbeData(data)
    // data.env = state.userData
    console.log('createCircuitData', JSON.stringify(data))
    state.simulationData = data
  },
  setCircuitPaths (state, paths) {
    state.result.paths = paths
  },
  findCircuitPaths (state, num) {
    this.commit('sim/removeHighLighting')
    if (!state.result.paths.length) return
    const paths = state.result.paths[num]
    const elcts = []
    for (let i = 0; i < paths.length; i++) {
      if (paths[i].startsWith('PW')) {
        elcts.push('Powersupply_' + paths[i].substr(4))
        continue
      } else if (paths[i].startsWith('VE') || paths[i].startsWith('AE')) {
        elcts.push('Multimeter_' + paths[i].substr(4))
        continue
      } else {
        const instance = this.$app.$children.find(child => child.code === paths[i])
        if (instance) elcts.push(instance.$el.id)
      }
    }
    console.log('findCircuitPath', elcts)
    state.elcts = elcts
    this.commit('sim/addHighLighting')
  },
  addHighLighting (state) {
    state.elcts.forEach(id => {
      const el = document.getElementById(id)
      if (el && !el.classList.contains('highlight')) el.classList.add('highlight')
    })
  },
  removeHighLighting (state) {
    state.elcts.forEach(id => {
      const el = document.getElementById(id)
      if (el && el.classList.contains('highlight')) el.classList.remove('highlight')
    })
  }
}

const actions = {
  sendSimulationData (context) {
    // create circuit data for checking valid circuit.
    context.commit('createCircuitData')
    const obj = {
      CompList: context.state.simulationData,
      env: context.state.userData
    }
    // get user access token
    const access = localStorage.getItem(TOKEN_KEY)
    instance.defaults.headers.common.Authorization = `${access}`
    // set simulation dialog message.
    context.commit('setSimulationMessage', {
      title: '시뮬레이션 결과를 위한 데이터 확인 중',
      contents: '시뮬레이션 결과를 기다리는 중입니다. 잠시 기다려주세요.',
      feedback: ''
    })
    instance.post('/circuit-ck/', JSON.stringify(obj))
      .then((res) => {
        if(res.data.error) {
          console.warn('시뮬레이션 회로 체크 오류:', res.data.message, res.data.description)
          context.state.result.pass = false
          context.commit('setSimulationMessage', {
            title: '시뮬레이션 에러',
            contents: '시뮬레이션 도중 에러가 발생했습니다.',
            feedback: res.data.message + " " + res.data.description
          })
          this.commit('stopSimulation')
          return
        }

        context.state.result.paths = []
        context.state.result.pass = true
        context.commit('setSimulationMessage', {
          title: '시뮬레이션 성공',
          contents: '사용한 부품 및 장치들의 시뮬레이션 결과를 확인해보세요.',
          feedback: ''
        })
        console.log('sendSimulationData Success', res.data)
        
        try {
          solver.processDataSet(res.data)
        } catch (error) {
          console.log("processDataSet", error)
        }

        console.log('after solver :', res.data)

        // set Result Data
        if (res.data.paths) context.state.result.paths = res.data.paths
        if ((typeof res.data.values) === 'string') context.state.result.values = JSON.parse(res.data.values)
        else context.state.result.values = res.data.values
        if (res.data.circuit_info) context.state.result.circuitinfo = res.data.circuit_info
        context.state.socket.uuid = res.data.socket_url
        context.state.socket.valid_comps = res.data.socket_comps

        // // pyspice data test
        // if (res.data.pyspice && this.state.elct.using.OS) {
        //   const pyspice_nodes = Object.keys(res.data.pyspice)

        //   Object.keys(this.state.elct.using.OS).forEach(idname => {
        //     const ydata = res.data.pyspice[pyspice_nodes[0]]
        //     // const ydata = res.data.pyspice[pyspice_nodes[pyspice_nodes.length - 1]]
        //     const xdata = Array.from({length: ydata.length}, (v, i) => i);
        //     // const channels = { ch1: { xdata: xdata, ydata: ydata }, ch2: { xdata: [], ydata: [] } }

        //     const instance = this.$app.$children.find(child => child.$el.id === idname)
        //     instance.displayStaticGraph(xdata, ydata)
        //     // instance.drawRealtimeGraph("period", ydata, [], xdata, 1000 )
        //     //  drawRealtimeGraph (mode, ydata1, ydata2, timeList = [], periodTime = 100)
        //   })
        // }

        this.commit('socket/connect', { data: context.state.socket })
        
        // update Mulimeter and Oscilloscope inner data
        // setMutlimeterData(this.$app.$children, context.state.result.values)
        // displayOscilloscopeGraph(this.$app.$children, context.state.result.values, this.state.elct.using)
      }).catch((err) => {
        // console.error('sendSimulationData', err)
        console.warn('sendSimulationData', err)

        context.state.result.pass = false
        context.commit('setSimulationMessage', {
          title: '시뮬레이션 에러',
          contents: '시뮬레이션 도중 에러가 발생했습니다.',
          // feedback: '유효하지 않은 입력 값 또는 잘못된 회로도 설계'
          feedback: '연결 오류'
        })

        this.commit('stopSimulation')
      })
  },
  // sendSimulationDataToSocket (context, payload) { // 주석 처리 되어서 사용되지 않음.
  //   context.commit('createCircuitData')
  //   if (!Object.keys(context.state.simulationData).length) return
  //   const converted = proccessConvertLegacyData(context.state.simulationData)
  //   console.log(converted)
  //   const obj = {
  //     CompList: converted,
  //     ino_code: context.state.arduino.code
  //   }
  //   console.log(obj)
  //   const access = localStorage.getItem(TOKEN_KEY)
  //   micomInstance.defaults.headers.common.Authorization = `${access}`
  //   context.commit('setSimulationMessage', {
  //     title: '시뮬레이션 결과를 위한 데이터 확인 중',
  //     contents: '시뮬레이션 결과를 기다리는 중입니다. 잠시 기다려주세요.',
  //     feedback: ''
  //   })
  //   micomInstance.post('/scripts/', obj)
  //     .then(res => {
  //       if (res.data.result) {
  //         context.state.result.pass = true
  //         context.commit('setSimulationMessage', {
  //           title: '시뮬레이션 성공',
  //           contents: '사용한 부품 및 장치들의 시뮬레이션 결과를 확인해보세요.',
  //           feedback: ''
  //         })
  //         context.state.socket.uuid = res.data.socket_url
  //         context.state.socket.valid_comps = res.data.valid_comps
  //         this.commit('misocket/connect', { data: context.state.socket })
  //       } else {
  //         context.state.result.pass = false
  //         let contents = ''; let feedback = ''
  //         if (res.data.feedback === 'compile error') {
  //           if (context.state.arduino.code.length > 0) {
  //             contents = '컴파일 에러: 시리얼 모니터를 확인하세요.'
  //             feedback = res.data.error
  //             context.commit('setSerialContents', { contents: res.data.error })
  //           } else {
  //             contents = '회로도 설계 및 아두이노 코드를 작성해주세요.'
  //             feedback = '회로도나 아두이노 코드 하나라도 없으면 시뮬레이션 할 수 없습니다.'
  //           }
  //         }
  //         context.commit('setSimulationMessage', {
  //           title: '시뮬레이션 실패',
  //           contents,
  //           feedback
  //         })
  //       }
  //     }).catch(err => {
  //       context.state.result.pass = false
  //       context.commit('setSimulationMessage', {
  //         title: '시뮬레이션 에러',
  //         contents: '시뮬레이션 도중 에러가 발생했습니다. 다시 시도해주세요.',
  //         feedback: err
  //       })
  //     })
  // },
  requestCodeDebugging (context) {
    context.state.arduino.status = '디버깅 시작'
    const formData = new FormData()
    formData.append('ino_code', context.state.arduino.code)
    context.commit('setSerialContents', 'Start debugging...\n')
    const access = localStorage.getItem(TOKEN_KEY)
    axios.defaults.headers.common.Authorization = `${access}`
    return new Promise((resolve, reject) => {
      axios.post('http://vlab.pusan.ac.kr/micom/compile/', formData
      ).then(res => {
        context.state.arduino.status = '디버깅 완료'
        context.commit('deleteSerialContents')
        context.commit('setSerialContents', res.data.ok)
        context.commit('setSerialContents', res.data.error)
        resolve(res.data)
      }).catch((err) => {
        context.state.arduino.status = '디버깅 에러'
        context.commit('deleteSerialContents')
        context.commit('setSerialContents', err)
        reject(err)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
